import { useQuery } from "@tanstack/react-query";
import { useCompanyAxis } from "@/api/use-company-context";
import { useSessionScope } from "@/auth/use-session-scope";
import { authority, type Authority } from "./api";
export const canOpenCafeteriaManagement = (value: Authority | undefined): boolean => value?.companies.some(company => company.actions.includes("read")) === true;
export const canOpenMyCafeteria = (value: Authority | undefined): boolean => value?.can_read_self === true;
export function useCafeteriaAuthority({ enabled = true }: { enabled?: boolean } = {}) {
  const scope = useSessionScope(), company = useCompanyAxis();
  return useQuery({ queryKey: ["cafeteria-authority", ...scope, company.active_legal_entity_id], queryFn: authority, enabled, staleTime: 60_000 });
}
